import { cloneConfig } from '@/schema/legacy-adapter'

// 这些组件挂载即可能执行脚本、启动视频或加载外部页面；模板只展示静态占位。
export function templatePreviewPlaceholder (node) {
  return { common: '通用图表', Dmap: '高德地图', iframe: '嵌入页面', video: '视频', Player: '视频流' }[node.component.name] || ''
}

// 模板预览使用独立静态副本，完整数据源仍保存在原模板中。
export function templatePreviewNodes (nodes, { runtimeSource = false } = {}) {
  const copy = cloneConfig(nodes)
  const visit = list => list.forEach(node => {
    if (node.children) return visit(node.children)
    node.dataType = 0
    node.time = 0
    for (const key of ['url', 'dataMethod', 'dataQuery', 'parameter', 'dataScript', 'dataFormatter', 'clickFormatter', 'echartFormatter', 'labelFormatter', 'titleFormatter', 'formatter', 'markerConfig', 'infoWindowConfig']) delete node[key]
    const placeholder = templatePreviewPlaceholder(node)
    if (placeholder) {
      node.component.name = node.component.prop = 'text'
      node.data = { value: placeholder }
      node.option = { textAlign: 'center', color: '#91b6cf', fontSize: 20 }
    }
    if (['productList', 'deviceList'].includes(node.component.name)) {
      const staticSource = node.option.dataSource === 'static' && (runtimeSource || node.option.templateListSource === 'static')
      node.option.dataSource = 'static'
      delete node.option.templateListSource
      if (!staticSource) node.data = []
    }
  })
  visit(copy)
  return copy
}
